"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _createStyles = _interopRequireDefault(require("../createStyles"));

var _excluded = ["children", "className", "style", "jss"];
var useStyles = (0, _createStyles["default"])(function (theme) {
  return {
    root: {
      width: '100%',
      overflowX: 'hidden',
      overflowY: 'auto',
      padding: "".concat(theme.spacer(2), "px 0"),
      marginBottom: 0,
      listStyleType: 'none'
    }
  };
}, {
  name: 'List'
});
exports.useStyles = useStyles;

var List = /*#__PURE__*/_react["default"].forwardRef(function List(_ref, ref) {
  var children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      _ref$jss = _ref.jss,
      jss = _ref$jss === void 0 ? {} : _ref$jss,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var classes = useStyles({
    jss: jss
  });
  return /*#__PURE__*/_react["default"].createElement("ul", (0, _extends2["default"])({}, props, {
    ref: ref,
    className: (0, _classnames["default"])(classes.root, className),
    style: style
  }), children);
});

List.propTypes = {
  /** Child items in the menu component */
  children: _propTypes["default"].node.isRequired,

  /** Additional class for root level */
  className: _propTypes["default"].string,

  /** Additional style for root level */
  style: _propTypes["default"].shape(),

  /** JSS overrides */
  jss: _propTypes["default"].oneOfType([_propTypes["default"].shape(), _propTypes["default"].func])
};
List.displayName = 'List';
var _default = List;
exports["default"] = _default;